import Cookies from 'js-cookie';
import BannerUtils from './BannerUtils.js';
import InscreenObserver from '@finn-no/inscreen-observer';

class BannerEventLogger {
    constructor(ctx) {
        this._trackingservice = ctx.trackingservice;
        this._apntag = ctx.apntag;
        this._sitesettings = ctx.sitesettings;

        this._impressionObserver = new InscreenObserver(
            ele => {
                this.logInscreen(ele, this);
            },
            {
                threshold: 0.5,
                timeout: 1000,
                once: true,
            }
        );
        this._bannerEles = [];
        this._creativeIds = {};
    }

    track(type, tagId, element, adObj) {
        const eventData = this._getEventData(tagId, element, adObj);
        // console.log(`### Track ${type}: ${tagId}`, eventData);

        this._trackingservice.trackEventObject({
            ecType: 'TRACKING',
            ecCategory: type,
            eventData,
        });
    }

    logInview(tagId, adObj) {
        const element = BannerUtils.getElementByAdPosition(tagId);
        this.track('inview', tagId, element, adObj);
        this.observeBanner(element);
    }

    logInscreen(element, logger) {
        if (logger._loggingEnabled()) {
            const tagId = element.getAttribute('data-astbanner-name');
            logger.track('inscreen', tagId, element, null);
        }
    }

    observeBanner(ele) {
        this._impressionObserver.observe(ele);
        this._bannerEles.push(ele);
    }

    unobserveBanners() {
        this._bannerEles.forEach(ele =>
            this._impressionObserver.unobserve(ele)
        );
        this._bannerEles = [];
    }

    isObservedBanner(ele) {
        return this._bannerEles.includes(ele);
    }

    _loggingEnabled() {
        return this._sitesettings.trackInscreen === 'true';
    }

    _getEventData(tagId, ele, adObj) {
        const url = document.baseURI;
        let listPos = '';
        let finnkode = '';

        if (adObj != null) {
            this._creativeIds[tagId] = adObj.creativeId;
        }
        const creativeId = this._creativeIds[tagId];

        if (url.includes('/search.html')) {
            listPos = Number(ele.getAttribute('data-position-index'));
        } else if (url.includes('/ad.html')) {
            finnkode = Number(new URL(url).searchParams.get('finnkode'));
        }

        const eventData = {
            'extra.position': tagId,
            'extra.vertical': BannerUtils.getMarketPlace(),
            'extra.session': Cookies.get('SESSION'),
            'extra.creativeId': creativeId,
            'extra.pageurl': window.location.href,
            'extra.listPos': listPos,
            'extra.abtest': BannerUtils.getAbTestCookie(),
            finnkode,
        };

        return eventData;
    }
}

export default BannerEventLogger;



// WEBPACK FOOTER //
// ./services/banner2/BannerEventLogger.js